//styles
import {
  VideoHeroWrapper,
  ContainerStyled,
  Thumb,
  ThumbImage,
} from './VideoHero.styles';

export function VideoHero() {
  return (
    <VideoHeroWrapper>
      <ContainerStyled>
        <Thumb>
          <ThumbImage
            src="/images/carrier-tms/video-hero/screen-dashboard.png"
            alt="CarrierGuide screenshot"
          />
        </Thumb>
      </ContainerStyled>
    </VideoHeroWrapper>
  );
}
